import { Check, X } from 'lucide-react';
import { PASSWORD_RULES } from '../../lib/passwordPolicy';

export const PasswordRules = ({ password = '', testId = 'password-rules' }) => (
  <ul className="space-y-1" data-testid={testId}>
    {PASSWORD_RULES.map(r => {
      const ok = r.test(password);
      return (
        <li key={r.label} className={`flex items-center gap-1.5 text-xs ${ok ? 'text-emerald-600' : 'text-slate-500'}`}>
          {ok ? <Check className="h-3.5 w-3.5" /> : <X className="h-3.5 w-3.5" />}{r.label}
        </li>
      );
    })}
  </ul>
);
